import { render } from "./EmailOptOutPage.vue?vue&type=template&id=cdea7bd0"
import script from "./EmailOptOutPage.vue?vue&type=script&lang=js"
export * from "./EmailOptOutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__